import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ModuleNames } from '../../../common/model/account-definition';
import { UserAccountService } from '../../../common/service/user-account.service';
import { NavigationService } from '../../../core/service/navigation.service';

@Injectable()
export class MortgageGuard {
  constructor(
    private _userAccount: UserAccountService,
    private _navigation: NavigationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this._userAccount.current.pipe(
      map(account => {
        if (account.hasAccess(ModuleNames.Mortgage)) {
          return true;
        }

        this._navigation.navigatePageNotFound();
        return false;
      })
    );
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate(childRoute, state);
  }
}
